/*
* Copyright (C) Regione Lombardia
*/
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
    ResponseGenericoBoolean,
    Utente,
    UtenteStatusEnum
} from '@models';
import { UtenteService } from '@shared/services/utente.service';

@Component({
    selector: 'app-pages-system-auth',
    template: '<div class="container-fluid text-center">Caricamento...</div>'
})
export class PagesSystemAuthComponent implements OnInit {

    constructor(
        private utenteService: UtenteService,
        private router: Router,
    ) { }

    ngOnInit() {
        this.utenteService.check().subscribe((responseCheck: ResponseGenericoBoolean) => {
            /* Verifico se c'è l'utente */
            if (responseCheck.response === false) {
                this.utenteService.logged = false;
                this.router.navigate(['/home']);
                return;
            }
            this.utenteService.getByHeader().subscribe((responseLoad: Utente) => {
                this.utenteService.logged = true;
                /* Verifico se l'utente è già registrato */
                if (!responseLoad.codiceFiscale || responseLoad.status.toString() === UtenteStatusEnum.REJECTED.toString()) {
                    this.router.navigate(['/private/gestione-utente/richiesta-profilo']);
                    return;
                }
                this.utenteService.utente = responseLoad;
                /* Verifico se l'utente è stato approvato */
                if (this.utenteService.utente.ruolo && this.utenteService.utente.status.toString() !== UtenteStatusEnum.COMPLETED.toString()) {
                    this.router.navigate(['/private/gestione-utente/attesa-profilo']);
                    return;
                }
                /* Utente registrato e approvato */
                this.router.navigate(['/private']);
            });
        }, error => {});
    }

}
